<template>
  <div id="container" class="md-layout md-alignment-center">
    <div
      class="md-layout-item md-xsmall-size-100 md-small-size-90 md-meduim-size-75 md-large-size-70 md-size-xlarge-45 md-size-40"
    >
      <GithubButtons />

      <Title id="title" />

      <div sticky-container>
        <div v-sticky sticky-offset="{ top: 0 }" sticky-side="both" on-stick="onStick">
          <SearchBar ref="searchBar" v-debounce:80ms="updated" :value="searchData" class="search-bar" />
        </div>

        <ResultTable :filter="searchData" />
      </div>
    </div>
  </div>
</template>

<script>
import Sticky from "vue-sticky-directive";

import GithubButtons from "./components/GithubButtons.vue";
import Title from "./components/Title.vue";
import SearchBar from "./components/SearchBar.vue";
import ResultTable from "./components/ResultTable.vue";

function prependHexPrefixIfNeeded(val) {
  if (
    !val.startsWith("0x") &&
    val.search(/\d+/) != -1 &&
    val.search(/[a-f]+/i) != -1 &&
    val.search(/[g-z]+/i) == -1
  ) {
    return "0x" + val;
  }
  return val;
}

export default {
  name: "App",
  directives: { Sticky },
  components: {
    GithubButtons,
    Title,
    SearchBar,
    ResultTable
  },
  methods: {
    onStick(state) {
      if (state.sticked) {
        this.$refs.searchBar.$el.classList.add("sticked");
      } else {
        this.$refs.searchBar.$el.classList.remove("sticked");
      }
    },
    updated(userInput) {
      this.userInput = prependHexPrefixIfNeeded(userInput);

      // Update URL
      history.replaceState({}, "", `/#/${this.userInput}`);
    }
  },
  computed: {
    searchData() {
      if (this.userInput === null) {
        return this.$route.params.pathMatch;
      }
      return this.userInput;
    }
  },
  data: () => ({
    userInput: null
  })
};
</script>

<style>
body {
  background: linear-gradient(rgb(99, 176, 204), rgb(179, 235, 222), whitesmoke)
      no-repeat top center,
    whitesmoke;
  background-size: 100vw 460px;
  object-fit: cover;
}
</style>

<style lang="scss" scoped>
#container {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#title {
  padding-top: 100px;
}

.search-bar {
  transition: padding 0.1s;
}

.sticked {
  background: white;
  box-shadow: 0px 3px 3px 0px #a5a5a541;
  padding: 0 5px 0 5px;
}
</style>